<template>
  <section class="comp-header-login bb-1px">
    <div class="header-inner">
      <div class="logo pt20"><router-link to="/"><img src="../assets/imgs/logo.png" alt="logo"></router-link></div>
      <div class="now-page f16 text-color-3 ml15"><span class="pl15">{{page}}</span></div>
      <div class="goto"><router-link tag="a" :to="{name: gotoLink}">{{gotoName}}</router-link></div>
    </div>
  </section>
</template>

<script>
  /**
   * @author yueheqin
   * @date 2018/12/18
   * @project kaoshizhongxin-pc
   * @desc 登录系列页面头部公共组件
   */
  export default {
    name: 'comp-header-login',
    props: {
      page: {
        type: String,
        default: '找回密码'
      },
      gotoName: {
        type: String,
        default: '返回登录'
      },
      gotoLink: {
        type: String,
        default: 'Login'
      }
    },
    data () {
      return {}
    }
  }
</script>

<style lang="less">
  @import "../styles/_mixins-wln";
  .comp-header-login {
    background: @white;
    width: 100%;
    .header-inner {
      width: @body-min-width;
      margin: 0 auto;
      display: flex;
      flex-direction: row;
    }
    .logo {
      width: 280px;
    }
    .now-page{
      flex: 1;
      span{
        border-left: 1px solid @border-color-1;
      }
    }
    .now-page, .goto{
      line-height: 40px;
      padding: 20px 0;
    }
  }
</style>
